import React, {Component} from 'react';
import {showError, showSuccess} from "../store/notification/actions";
import withStore from "../hoc/withStore";
import {connect} from "react-redux";

class NotificationHelper extends Component {
    componentDidMount() {
        const {error, message, showError, showSuccess} = this.props;
        
        if(error) {
            showError(error);
        }

        if(message) {
            showSuccess(message);
        }
    }

    render() {
        return null;
    }
}

const mapDispatchToProps = dispatch => ({
    showError: (message) => dispatch(showError(message)),
    showSuccess: (message) => dispatch(showSuccess(message)),
});

export default withStore(connect(null, mapDispatchToProps)(NotificationHelper));
